const DATE: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' }
const TIME: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' }

const FORMATS = {
  'DD.MM.YYYY': ['pl-PL', DATE],
  'DD/MM/YYYY': ['en-GB', DATE],
  'HH:mm': ['pl-PL', TIME],
  'DD.MM.YYYY, HH:mm': ['pl-PL', { ...DATE, ...TIME }],
  'M': ['en-GB', { month: 'numeric' }],
} satisfies Record<string, [string, Intl.DateTimeFormatOptions]>

export const formatDate = (value: string, format: keyof typeof FORMATS = 'DD.MM.YYYY') => {
  const localDateTime = value.slice(0, 16)
  const dateValue = localDateTime.length === 10 ? `${localDateTime}T00:00` : localDateTime
  const date = new Date(`${dateValue}:00Z`)

  if (Number.isNaN(date.getTime())) {
    console.error(`Invalid date value: ${value}`)
    return value
  }

  const [locale, options] = FORMATS[format]

  return new Intl.DateTimeFormat(locale, { ...options, timeZone: 'UTC' }).format(date)
}
